module.exports = __webpack_public_path__ + "static/media/load.4aa2a73f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/load/load.gif
// module id = 1230
// module chunks = 0